import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const loginRoute = {
  path: 'login',
  url: '/login',
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('../../../shell/login/login.module').then(m => m.LoginModule),
};
